













































































































































































import { Component, Vue, Ref } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import Questions from "@/components/cards/ConversationQuestions.vue";
import NewQuestions from "@/components/modals/NewQuestion.vue";
import { Dialog, Popup, Notify } from "vant";
import axios from "axios";
import { englishjanala } from "../protos";
import Spiner from "@/components/englishjanala/Spiner.vue";

// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */

@Component({
  components: {
    NewQuestions,
    Questions,
    sidebar,
    Spiner,
  },
})
export default class Exercise extends Vue {
  ConvId: any;
  Spiner: boolean = true;
  DivId = -1;
  EditId = -1;
  show = false;
  hover: boolean = false;
  questionLength: string = "";
  Exercise: any = null;
  questions: any = null;
  errors: any = [];
  category: any = null;
  edit_title = false;
  NewQuestion(question: any) {
    // alert("hi2");
    this.questionLength = String(this.Exercise.questions.length + 1);

    for (let i = 0; i < 4; i++) {
      if (question.answerIndices[i] == true) {
        question.answerIndices[i] = 1;
      } else question.answerIndices[i] = 0;
    }
    if (question.questionType == "TRANSLATE_REARRANGE")
      question.reorderAnswerList = question.reorderAnswerList.split(" ");

    this.Exercise.questions.push({
      reorderShuffleList: [],
      id: this.questionLength,
      imageUrl: question.imageUrl,
      questionTitle: question.questionTitle,
      questionType: question.questionType,
      reorderAnswerList: question.reorderAnswerList,
      answerId: question.answerId,
      answerOptions: question.answerOptions,
      answerIndices: question.answerIndices,
    });

    Notify({ type: "success", message: "Question added" });
    // chapter.name = chapter.id = chapter.imageUrl = chapter.contributorName = "";
    question.questionTitle = "";
    question.imageUrl = "";
    (question.questionType = ""), (question.answerOptions = ["", "", "", ""]);
    question.answerId = 0;
    question.answerIndices = [0, 0, 0, 0];
    question.reorderAnswerList = [];

    window.scrollTo(0, document.body.scrollHeight);
  }

  UpdateExercise() {
    const data = { category_id: this.ConversationId, exercise: this.Exercise };

    const response = axios
      .post(
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/UpdateConversationExercise",
        data
      )
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Exercise is not Updated" });
      });
    Notify({ type: "success", message: "Exercise is Updated" });
  }
  EditTitle() {
    this.edit_title = true;
  }

  //
  async mounted() {
    const catId = this.$route.params.ConversationId;
    const exerciseId = this.$route.params.ExerciseId;
    const PassData = { category_id: catId, exercise_id: exerciseId };

    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/GetConversationExercise",
      PassData
    );
    const data = response.data;

    this.Exercise = data.exercise;
    this.Spiner = false;
  }

  get ConversationId() {
    this.ConvId = this.$route.params.ConversationId;
    return this.$route.params.ConversationId;
  }
  get ExerciseId() {
    return this.$route.params.ExerciseId;
  }
}
